import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Link as ScrollLink } from 'react-scroll';
import {
  AppBar,
  Box,
  Button,
  Container,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Toolbar,
  Typography,
  useMediaQuery,
  useScrollTrigger,
  Slide
} from '@mui/material';
import { Menu as MenuIcon } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';

function HideOnScroll(props) {
  const { children } = props;
  const trigger = useScrollTrigger();

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
}

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const scrollToSection = (sectionId) => {
    if (mobileOpen) setMobileOpen(false);
  };

  const navItems = [
    { name: 'Inicio', path: '/' },
    { name: 'Funcionalidades', path: '/#funcionalidades', isScroll: true },
    { name: 'Precios', path: '/precios' },
    { name: 'Contacto', path: '/contacto' }
  ];

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center', py: 2 }}>
      <Typography variant="h6" sx={{ my: 2 }}>
        MekaSys
      </Typography>
      <List>
        {navItems.map((item) => (
          <ListItem 
            key={item.name} 
            sx={{ textAlign: 'center' }}
            component={item.isScroll ? ScrollLink : RouterLink}
            to={item.isScroll ? item.path.substring(2) : item.path}
            smooth={item.isScroll}
            duration={500}
            onClick={() => scrollToSection(item.path)}
          >
            <ListItemText primary={item.name} />
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <>
      <HideOnScroll>
        <AppBar position="fixed" color="default" elevation={1} sx={{ backgroundColor: 'rgba(255, 255, 255, 0.98)' }}>
          <Container maxWidth="lg">
            <Toolbar disableGutters>
              <Typography
                variant="h6"
                component={RouterLink}
                to="/"
                sx={{
                  mr: 2,
                  display: { xs: 'none', md: 'flex' },
                  fontFamily: 'Montserrat',
                  fontWeight: 700,
                  letterSpacing: '.2rem',
                  color: 'primary.main',
                  textDecoration: 'none',
                }}
              >
                MekaSys
              </Typography>

              {isMobile ? (
                <>
                  <Typography
                    variant="h6"
                    component={RouterLink}
                    to="/"
                    sx={{
                      flexGrow: 1,
                      fontFamily: 'Montserrat',
                      fontWeight: 700,
                      letterSpacing: '.2rem',
                      color: 'primary.main',
                      textDecoration: 'none',
                    }}
                  >
                    MekaSys
                  </Typography>
                  <IconButton
                    color="primary"
                    aria-label="abrir menú"
                    edge="end"
                    onClick={handleDrawerToggle}
                  >
                    <MenuIcon />
                  </IconButton>
                </>
              ) : (
                <>
                  <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center' }}>
                    {navItems.map((item) => {
                      if (item.isScroll) {
                        return (
                          <ScrollLink
                            key={item.name}
                            to={item.path.substring(2)}
                            spy={true}
                            smooth={true}
                            duration={500}
                            style={{ cursor: 'pointer' }}
                          >
                            <Button color="inherit" sx={{ mx: 1 }}>
                              {item.name}
                            </Button>
                          </ScrollLink>
                        );
                      }
                      return (
                        <Button
                          key={item.name}
                          component={RouterLink}
                          to={item.path}
                          color="inherit"
                          sx={{ mx: 1 }}
                        >
                          {item.name}
                        </Button>
                      );
                    })}
                  </Box>
                </>
              )}
            </Toolbar>
          </Container>
        </AppBar>
      </HideOnScroll>
      <Toolbar /> {/* Espacio para compensar la AppBar fija */}

      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true, // Mejor rendimiento en móviles
        }}
        sx={{
          display: { xs: 'block', md: 'none' },
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width: 240 },
        }}
      >
        {drawer}
      </Drawer>
    </>
  );
};

export default Navbar; 